document.addEventListener('click', function (e) {
  var opener = e.target.closest('[data-tier-open]');
  if (opener) {
    var dialog = document.getElementById('tier-modal-' + opener.getAttribute('data-tier-open'));
    if (dialog && typeof dialog.showModal === 'function') dialog.showModal();
    return;
  }
  var closer = e.target.closest('[data-tier-close]');
  if (closer) {
    var d = closer.closest('dialog');
    if (d) d.close();
    return;
  }
  if (e.target.tagName === 'DIALOG') {
    e.target.close();
  }
});
